<template>
  <v-container>

    <v-alert v-model="alert" type="success" border="left" close-text="Close Alert" dismissible>
      The streaming session has been added successfully !
    </v-alert>

    <v-row>

      <v-col
        cols="12"
        sm="6"
      >

  <v-card>

    <v-card-text class="ps-12">

        <v-form v-model="valid">
    <v-container>

      <v-row>
      <p><a href="https://docs.google.com/spreadsheets/d/11634lWD_C8NOsfbmZHbgzib6PMRsFlEo6yTmoL9WBpw/edit#gid=0" target="_blank">
      Select the name of your self-streamed session</a>, a date and enter the Zoom link of the session.</p>
      </v-row>

      <v-row>
      <v-select
        v-model="session_selected"
        :items="sessions"
        item-text="name_formatted"
        item-value="id"
        dense
        label="Select the session"
        required
        :rules="sessionRules"
      ></v-select>

      </v-row>
      <v-row>
        <v-date-picker
          v-model="date"
          class="mt-4"
          min="2021-06-27"
          max="2021-07-30"
          :landscape="true"
          required
        ></v-date-picker>
      </v-row> 

      <v-row class="mb-6">
      
      </v-row>
      <v-row>
        <label class="mr-2">From: </label> 
        <vue-timepicker v-model="start_time" placeholder="Start Time" :minute-interval="15" format="hh:mm A" class="mr-3"></vue-timepicker>
        
        <label class="mr-2">To: </label>  
        <vue-timepicker v-model="end_time" placeholder="End Time" :minute-interval="15" format="hh:mm A" class="mr-3"></vue-timepicker>

        <p class="mt-2">Please use <a href="https://www.timeanddate.com/time/zones/et" target="_blank">Eastern Time (ET)</a> - e.g. New-York time.</p>

      </v-row>

      <v-row v-if="start_not_valid">
        <v-alert type="error">
          Start time not complete.
        </v-alert>
      </v-row>

      <v-row v-if="end_not_valid">
        <v-alert type="error">
          End time not complete.
        </v-alert>
      </v-row>

      <v-row>
        <v-text-field
          v-model="zoom"
          label="Zoom link"
          placeholder="https://zoom.us/...."
          :rules="zoomRules"
          required
        ></v-text-field>
      </v-row>

      <v-row>
        <v-text-field
          v-model="name"
          label="Your name"
          :rules="nameRules"
          required
        ></v-text-field>
      </v-row>

      <v-row>
        <v-text-field
          v-model="email"
          label="Your email (will not be published)"
          :rules="emailRules"
          required
        ></v-text-field>
      </v-row>

      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="validate"
      >
        Validate
      </v-btn>

            </v-container>
  </v-form>

    </v-card-text>
  </v-card>

      </v-col>


      <v-col
        cols="12"
        sm="6"
      >

        <v-card>
          <v-card-text class="ps-12">
            <h2>Proposed sessions</h2>
            <div v-if="streams.length">
                <v-list-item v-for="stream in streams" :key="stream.id">
                  <v-list-item-content>
                    <v-list-item-title>{{ get_session_name(stream.session_id) }}</v-list-item-title>
                    <v-list-item-subtitle>Date: <strong>{{ stream.date }}</strong> - from: <strong>{{ stream.start_time }}</strong> 
                    to <strong>{{ stream.end_time }}</strong> <a href="https://www.timeanddate.com/time/zones/et" target="_blank">Eastern Time (ET)</a></v-list-item-subtitle>
                    <v-list-item-subtitle>Zoom link: {{ stream.zoom }}</v-list-item-subtitle>
                    <v-list-item-subtitle>Streaming session proposed by: <em>{{ stream.name }}</em></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
            </div>
          <div v-else>
            <p class="mt-2"><em>No sessions proposed yet</em>.</p>
          </div>          

          </v-card-text>
        </v-card>

      </v-col>


  </v-row>

  </v-container>
</template>

<script>
// Main JS (in UMD format)
import VueTimepicker from 'vue2-timepicker'
// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'
  export default {
    data () {
      return {
        alert: false,
        start_time: {hh: '', mm: '', A: ''},
        end_time: {hh: '', mm: '', A: ''},
        date: '',
        streams: [],
        sessions: [],
        session_selected: '',
        name_formatted: '',
        name: '',
        zoom: '',
        email: '',
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid',
        ],
        nameRules: [
          v => !!v || 'Name is required'
        ],
        zoomRules: [
          v => !!v || 'The Zoom link is required'
        ],
        sessionRules: [
          v => !!v || 'Please select a session'
        ],
        valid: false,
        start_not_valid: false,
        end_not_valid: false,
      }
    },
    computed: {
      slot: function () {
        return { 'session_id': this.session_selected, 
        'date': this.date, 'start_time': this.start_time, 'end_time': this.end_time, 
        'zoom': this.zoom, 'email': this.email, 'name': this.name}
      },
      slot_formated: function () {
        return { 'id': this.session_selected, 
        'date': this.date, 
        'start_time': this.start_time.hh + ':' + this.start_time.mm + ':' + this.start_time.A,
        'end_time': this.end_time.hh + ':' + this.end_time.mm + ':' + this.end_time.A,
        'zoom': this.zoom, 'email': this.email, 'name': this.name}
      }
    },
    components: {
      "vue-timepicker": VueTimepicker
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      fetchData: function() {
        window.axios
          .get('streams')
          .then(response => this.streams = response.data);

        window.axios
          .get('streams/sessions')
          .then(response => this.sessions = response.data);        

      },
      validate () {
        if ((this.start_time.hh == '') || (this.start_time.mm == '') || (this.start_time.A == '')) {
          this.start_not_valid = true
        } else {
          this.start_not_valid = false
        }

        if ((this.end_time.hh == '') || (this.end_time.mm == '') || (this.end_time.A == '')) {
          this.end_not_valid = true
        } else {
          this.end_not_valid = false
        }

        if ((this.start_not_valid == false) && (this.end_not_valid == false)) {
          this.addSlot();
          this.valid = false;
        }

      },
      addSlot() {
        window.axios
          .post('streams/store', this.slot)
          .then(this.streams.unshift(this.slot_formated))
          .catch();
          this.alert = true;
      },
      get_session_name: function (id) {
        if ((id > 0) && (this.sessions.length > 0)) {
          return this.sessions.find(x => x.id == id).name_formatted;
        } else {
          return '';
        }
        
      }
    }
  }
</script>
